/* eslint-disable max-len */
import { SaveOutlined, PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
  Breadcrumb, Button, Form, Input, Select, Card, Row, Col, Table,
  Modal,
  Popover,
  message,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';

import styles from './CreateDevicesType.module.less';
import useCreateDevicesType from './useCreateDevicesType';

const { Option } = Select;
const { Item } = Form;

function CreateDevicesType() {

  const { t } = useTranslation();
  const ExpRegSoloNumeros="^[0-9]+$";
  const ExpRegSoloNumerosDecimal="^[0-9]+([.])?([0-9]+)?$";

  const {
    form,
    onFinishFailed, onFinish,
    formOnValuesChange,
    isEditDefault,
    createEditValues,
    cancelCreateEditDeviceType,
    loading,
    columns,
    dataSource,
    openModalVar,
    setOpenModalVar,
    createVarModal,
    dataFormModal,
    changeVar,
    createEditModalSave,
    saveLoading,
    businessData
  } = useCreateDevicesType();

  const content = (
    <div>
      <p>{'1 -> Read coils or digital outputs'}</p>
      <p>{'2 -> Read digital inputs'}</p>
      <p>{'3 -> Read registers or analog outputs'}</p>
      <p>{'4 -> Read analog inputs'}</p>
      <p>{'5 -> Write single coil or output'}</p>
      <p>{'6 -> Write single register'}</p>
      <p>{'15 -> Write multiple coils or outputs'}</p>
      <p>{'16 -> Write multiple registers'}</p>
    </div>
  );

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Form 
          layout="vertical"
          form={form}
          initialValues={createEditValues}
          onValuesChange={formOnValuesChange}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {/* Breadcrumb */}
          <Card style={{ width: '100%', marginBottom: '1rem' }}>
            <Row>
              <Col xs={{span: 24 }} sm={{span: 24 }} md={{span: 20 }} lg={{span: 20 }} xl={{span: 20 }}
              >
                {(isEditDefault)
                    ?  <div className={styles.section_title}>{t('views.create_device_types.edit_device_type')}</div>
                    :  <div className={styles.section_title}>{t('views.create_device_types.new_device_type')}</div>
                }
                <Breadcrumb className={styles.date_wrapper}>
                  <>
                    <Breadcrumb.Item className={styles.breadcrumb}>
                      <Link to="/dispositivos/tipo-dispositivo">{t('menu_items.main.device_types')}</Link>
                    </Breadcrumb.Item>
                  </>
                  {(isEditDefault)
                    ? (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.breadcrumb}>{isEditDefault}</Breadcrumb.Item>
                      </>
                    )
                    : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_device_types.new_device_type')}</Breadcrumb.Item>}
                </Breadcrumb>
              </Col>

              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}
                className={styles.column_btn}
              > 
                <Button onClick={cancelCreateEditDeviceType}>X</Button>

                <Button key="button"  className='m_l' type="primary" loading={saveLoading} htmlType="submit" icon={(!isEditDefault) ?<PlusOutlined />:null} >
                 {(!isEditDefault) ? t('views.create_business_type.buttons.create') : t('views.create_business_type.buttons.update') }
                </Button> 

              </Col>
              
            </Row>
          </Card>

          {/* Formulario principal */}
          <Card style={{ width: '100%' }}>
            <div className={styles.containerForm}>

              {/* Formulario */}
              <Row gutter={[16, 8]}>

                <Col xs={{ span: 24, order: 1, }} sm={{ span: 24, order: 1, }} md={{ span: 24, order: 1, }} lg={{ span: 12, order: 1, }} xl={{ span: 12, order: 1, }}
                >

                  <Item
                    className={styles.label}
                    label={t('views.dynamic_device_types_create_edit.labels.device_type_name')}
                    name="device_type_name"
                    rules={[
                      {
                        required: true,
                        message: t('views.dynamic_device_types_create_edit.feedbacks.required_input'),
                      },
                    ]}
                  >
                    <Input className={styles.input} />
                  </Item>

                </Col>

                <Col xs={{ span: 24, order: 2}} sm={{ span: 24, order: 2}} md={{ span: 24, order: 2}} lg={{ span: 12, order: 2}} xl={{ span: 12, order: 2}}
                >

                  <Item
                    className={styles.label}
                    label={t('views.dynamic_device_types_create_edit.labels.device_type_description')}
                    name="device_type_description"
                    rules={[
                      {
                        required: true,
                        message: t('views.dynamic_device_types_create_edit.feedbacks.required_input'),
                      },
                    ]}
                  >
                    <Input className={styles.input}/>
                  </Item> 
                  
                </Col> 

               { 
                <Col xs={{ span: 24, order: 2}} sm={{ span: 24, order: 2}} md={{ span: 24, order: 2}} lg={{ span: 12, order: 2}} xl={{ span: 12, order: 2}}> 
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.business_line')}
                    name="business_type_id"//busines_id
                    rules={[
                      {
                        required: true,
                        message: t('forms.users.placeholders.business_line'),
                      },
                    ]}
                  >
                    <Select 
                      disabled={isEditDefault}
                      style={{ width: '100%' }}
                      placeholder={t('forms.users.placeholders.business_line')} 
                      options={businessData}
                    /> 
                  </Form.Item>
                </Col>
               } 


              </Row>

              {/* Solicitar Variables */}
              <Row gutter={[16, 8]}>
                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}
                >
                  <Item
                    className={styles.label_hide_input}
                    label="Variables" 
                  />
                </Col>

                <Col xs={{ span: 24, order: 1, }} sm={{ span: 24, order: 1, }} md={{ span: 24, order: 1, }} lg={{ span: 12, order: 1, }} xl={{ span: 12, order: 1, }}

                >
                  <div style={{ textAlign: 'right' }}>
                    <Button type="link" icon={<PlusOutlined />} onClick={() =>createVarModal()}>
                      {t('views.dynamic_device_types_create_edit.labels.new_var')}
                    </Button>
                  </div>
                </Col>

                {/* Modal Variable */}
                <Modal
                  title="Variable"
                  style={{ top: 50 }}
                  visible={openModalVar}
                  okText={t('views.create_devices.form.button')}
                  onOk={() => createEditModalSave()}
                  onCancel={() => setOpenModalVar(false)}
                  width={1000}
                >
                  <div className={styles.containerModal}>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.device_type_name_g')}`}
                    >
                      <Input style={{ width: '100%' }} value={dataFormModal.variable_name} onChange={(e) => {
                          changeVar('variable_name',e.target.value);
                      }}/>
                    </Item>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.variable_key_g')}`}
                    >
                      <Input style={{ width: '100%' }} value={dataFormModal.variable_key} onChange={(e) => {
                          changeVar('variable_key',e.target.value);
                      }}/>
                    </Item> 

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.variable_descriptor_g')}`}
                    >
                      <Input style={{ width: '100%' }} placeholder={'v={VF1}\nx=v[1]'} value={dataFormModal.variable_descriptor}  onChange={(e) => {
                          changeVar('variable_descriptor',e.target.value);
                      }}/>
                    </Item>
                   
                    {/* 

                      <Item
                        className={styles.short_input}
                        labelAlign="left"
                        label={`${t('views.dynamic_device_types_create_edit.labels.modbus_name_g')}`}
                      >
                        <Input style={{ width: '100%' }} value={dataFormModal.modbus_name}  onChange={(e) => {
                            changeVar('modbus_name',e.target.value);
                        }}/>
                      </Item>

                    */} 

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={(
                        <div style={{ width: '100%' }}>
                          {t('views.dynamic_device_types_create_edit.labels.modbus_function_g')}
                          {' '}
                          {'   '}
                          <Popover content={content} title={<div style={{ paddingLeft: '5px' }}>{t('views.dynamic_device_types_create_edit.labels.legend_modbus_function')}</div>}>
                            <InfoCircleOutlined style={{ color: '#ff812e' }} />
                          </Popover>
                        </div>
                      )}
                    >
                      <Select
                        className={`${styles.take_two_columns}`}
                        labelAlign="left"
                        value={dataFormModal.modbus_function}
                        onSelect={(value) => {
                          changeVar('modbus_function',value); 
                        }}
                      >
                        <Option value="1">1 {`->`} Read coils or digital outputs </Option>
                        <Option value="2">2 {`->`} Read digital inputs </Option>
                        <Option value="3">3 {`->`} Read registers or analog outputs </Option>
                        <Option value="4">4 {`->`} Read analog inputs </Option>
                        <Option value="5">5 {`->`} Write single coil or output </Option>
                        <Option value="6">6 {`->`} Write single register </Option>
                        <Option value="15">15 {`->`} Write multiple coils or outputs </Option>
                        <Option value="16">16 {`->`} Write multiple registers </Option>
                      </Select>
                    </Item>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.modbus_direction_g')}`}
                    >
                      <Input style={{ width: '100%' }} value={dataFormModal.modbus_direction}  onChange={(e) => {
                          if(e.target.value.match(ExpRegSoloNumeros)!=null){
                            if(e.target.value >= 0 && e.target.value <= 65535){ 
                              changeVar('modbus_direction',e.target.value);
                            }else{ 
                              message.error(t('views.dynamic_device_types_create_edit.feedbacks.valid_modbus_direction'));
                            }
                          }else if(e.target.value ==''){
                            changeVar('modbus_direction','');
                          }
                      }}/>
                    </Item>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.factor_to_multiply_g')}`}
                    >
                      <Input style={{ width: '100%' }} value={dataFormModal.factor_to_multiply}  onChange={(e) => {
                          if(e.target.value.match(ExpRegSoloNumerosDecimal)!=null){
                              changeVar('factor_to_multiply',e.target.value);
                          }else if(e.target.value ==''){
                            changeVar('factor_to_multiply','');
                          }
                      }}/>
                    </Item>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.modbus_size')}`}
                    >
                      <Input style={{ width: '100%' }} value={dataFormModal.modbus_size}  onChange={(e) => {
                         
                          if(e.target.value.match(ExpRegSoloNumeros)!=null){
                            changeVar('modbus_size',e.target.value);
                          }else if(e.target.value ==''){
                            changeVar('modbus_size','');
                          }
                      }}/>
                    </Item>

                    <Item
                      className={styles.short_input}
                      labelAlign="left"
                      label={`${t('views.dynamic_device_types_create_edit.labels.datatypes')}`}
                    >
                      <Select
                        className={`${styles.take_two_columns}`}
                        labelAlign="left"
                        value={dataFormModal.datatypes}
                        onSelect={(value) => { 
                          changeVar('datatypes',value); 
                        }}
                      >
                        <Option value="U32">U32</Option>
                        <Option value="U16">U16</Option>
                        <Option value="U8">U8</Option>
                        <Option value="I32">I32</Option>
                        <Option value="I16">I16</Option>
                        <Option value="I8">I8</Option>
                        <Option value="F">F</Option>
                        <Option value="SG">SG</Option>
                        <Option value="B">B</Option>

                      </Select>
                    </Item>

                  </div>

                </Modal>

              </Row>

              {/* Listado de variable */}
              <Row gutter={[16, 8]}>
                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 24,order: 1, }} xl={{span: 24,   order: 1, }}
                >

                  <Table
                    loading={loading}
                    className={styles.table}
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    rowKey={({ index }) => index}
                  />

                </Col>
              </Row>
            </div>
          </Card>

        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateDevicesType);
